import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { IdObject } from "../models/IdObject";
import { ISearchQueryRequest } from "../models/ISearchQueryRequest";
import searchRequestAtom from "../recoils/useSearchRequest/searchRequestAtom";

export function useInitSearchQueryRequest(searchedProduct: any) {
    const [searchRequest,setSearchRequest] = useRecoilState(searchRequestAtom);
  useEffect(() => {
    if(searchedProduct){
        const initArray: IdObject[] = [{id: searchedProduct[0].category?.categoryId.toString()} as IdObject];
        let oldRequest: ISearchQueryRequest = {...searchRequest, categoryFilter: [...initArray]}
        setSearchRequest(oldRequest);
    }
  },[searchedProduct]);
}
